<section class="banner 111">
  <div #air id="air" class='air kenburns-top'></div>

  <app-nav class="w-100"></app-nav>

  <app-page-heading [heading]="data_type" [sub_heading]="ou_object.name"></app-page-heading>
</section>

<div class="container-fluid">
  <div class="row">
    <app-services-view [items]="items" [filterItems]="items" [object]="ou_object"
      [type]="data_type"></app-services-view>
    <div class=" d-flex align-items-center justify-content-center flex-row w-100 container-fluid">
      <button *ngIf="data.length > 0;else loadingBar"
        class="m-3 btn-flex bg-primary py-2 px-5 d-flex flex-row align-items-center justify-content-center gap-3"
        [useExistingCss]="true"
        [printStyle]="{'#print-data':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl'},'body':{'direction': 'rtl'}}"
        printSectionId="print-data" ngxPrint>
        <h3>Bulk Print</h3>
        <i class="pi pi-print" style="font-size: larger;"></i>
      </button>
      <ng-template #loadingBar>
        <p-progressSpinner strokeWidth="2"></p-progressSpinner>
      </ng-template>
    </div>
  </div>
</div>

<!-- Printing Service Use Only For bulk data -->
<div *ngIf="data.length > 0" style="display: none;width: 100%;" id="print-data">
  <div *ngFor="let currentItem of data">
    <!-- Printing Service Use Only -->
    <div *ngIf="currentItem && currentItem?.fields.length > 0">
      <h2 class="card-title" style="font-weight: 600; color: var(--color-1);margin-bottom: 2rem;">
        {{currentItem.name}}</h2>

      <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
        <ng-container *ngIf="currentItem && currentItem.breadcrumbs && currentItem.breadcrumbs.length > 0">
          <span class="d-flex flex-row align-items-center" *ngFor="let parent of sortByDepth(currentItem?.breadcrumbs)">
            <span class="btn-flex custom-bredcrum-btn ou-item  align-items-center" style="background-color: grey;">
              <span class="btn-css  mx-2 font-0_5rem" role="button"
                [routerLink]="'/category/'+parent.id">{{parent.label}}</span>
              <span class="icon-box" style="background-color: grey;">
                <img src="{{GlobalConstants.staticFilesURL + parent?.icon}}"
                  *ngIf="checkisImg(parent?.icon); else elseBlock" class="img-fluid" alt="">
                <ng-template #elseBlock>
                  <i class="pi pi-{{parent.icon}} img-fluid"></i>
                </ng-template>
              </span>
            </span>
            <span>
              <i class="pi pi-fw pi-angle-left"></i>
            </span>
          </span>
        </ng-container>
        <span style="background-color: grey;"
          class=" my-1 btn-flex mx-1 ou-item active custom-bredcrum-btn align-items-center">
          <span role="button" class="btn-css mx-2 font-0_5rem"
            [routerLink]="'/category/'+currentItem?.id">{{currentItem?.name}}</span>
          <span class="icon-box" style="background-color: grey;">
            <img src="{{GlobalConstants.staticFilesURL + currentItem?.image_sq}}"
              *ngIf="checkisImg(currentItem?.image_sq); else elseBlock" class="img-fluid" alt="">
            <ng-template #elseBlock>
              <i class="pi pi-{{currentItem?.image}} align-self-center"></i>
            </ng-template>
          </span>
        </span>
      </div>

      <div style="margin:1rem 0;"></div>
      <span class="hr"></span>
      <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
        <span *ngFor="let field of currentItem?.fields; let i = index">
          <p-accordionTab *ngIf="field.data && field.data != '' && field.data !=null" class="my-3" iconPos="end"
            [selected]="true">
            <ng-template pTemplate="header">
              <div class="d-flex align-items-center">
                <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                <span class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="row">
                <!-- For View -->
                <div class="col-12">
                  <div [ngSwitch]="getFieldType(field.label?.type)">
                    <!-- For text -->
                    <div *ngSwitchCase="'text'">
                      <div class=" line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="field.data | safeHTML">
                      </div>
                    </div>
                    <!-- Rich text -->
                    <div *ngSwitchCase="'Rich text'">
                      <div class=" line-space mb-0 datacontent" *ngIf="field.data" [innerHTML]="field.data | safeHTML">
                      </div>
                    </div>
                    <div *ngSwitchCase="'Upload Image'">
                      <img [hidden]="field.data == ''" class="img-fluid upload-img"
                        [src]="GlobalConstants.staticFilesURL+field.data">
                    </div>
                    <div *ngSwitchCase="'Upload Document'">
                      <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                        [href]="GlobalConstants.staticFilesURL+field.data">
                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                      </a>

                    </div>
                    <div *ngSwitchCase="'Data Item'">
                      <p class="color-bold">{{field?.data?.name}}</p>
                      <p-accordion class="w-full" [multiple]="true">
                        <p-accordionTab class="my-3" [selected]="true"
                          *ngFor="let field of field.data.fields; let i = index" iconPos="end">
                          <ng-template pTemplate="header">
                            <div class="d-flex align-items-center">
                              <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                              <span class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                            </div>
                          </ng-template>
                          <ng-template pTemplate="content">
                            <div class="row">
                              <div class="col-10">
                                <div [ngSwitch]="getFieldType(field.label?.type)">
                                  <!-- For text -->
                                  <div *ngSwitchCase="'text'">
                                    <div class=" line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                      [innerHTML]="field.data | safeHTML">
                                    </div>
                                  </div>
                                  <!-- Rich text -->
                                  <div *ngSwitchCase="'Rich text'">
                                    <div class=" line-space mb-0 datacontent flex-column" *ngIf="field.data"
                                      [innerHTML]="field.data | safeHTML">
                                    </div>
                                  </div>
                                  <div *ngSwitchCase="'Upload Image'">
                                    <img [hidden]="field.data == ''" class="img-fluid upload-img"
                                      [src]="GlobalConstants.staticFilesURL+field.data">
                                  </div>
                                  <div *ngSwitchCase="'Upload Document'">
                                    <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                                      [href]="GlobalConstants.staticFilesURL+field.data">
                                      <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" |
                                      translator}}
                                    </a>

                                  </div>
                                  <div *ngSwitchCase="'Data Item'">
                                  </div>
                                  <div *ngSwitchDefault>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </p-accordionTab>
                      </p-accordion>
                    </div>
                    <div *ngSwitchDefault></div>
                  </div>
                </div>
                <!-- <div class="col-2 d-flex justify-content-end">
                          <div *ngIf="hasPermission('u') && editPermission" class="editbutton"
                              (click)="editFlag = i; editDataSave(field.data)">
                              <p-button icon="pi pi-fw pi-pencil"></p-button>
                          </div>
                      </div> -->
              </div>
            </ng-template>
          </p-accordionTab>
        </span>
      </p-accordion>
    </div>
  </div>
</div>


<app-footer></app-footer>